import React from 'react';
import TalentForm from './TalentForm';
import ModalPortal from './ModalPortal';
import ModalFrame from './ModalFrame';

const TalentFormModal = ({
  isOpen,
  onClose,
  onSuccess,
  initialData = {},
  title = "Create Talent",
  submitText = "Create",
  jobApplicationInfo = null
}) => {
  if (!isOpen) return null;

  return (
    <ModalPortal onClose={onClose} ariaLabel={title || 'Talent form'}>
      <ModalFrame size="xl">
        <ModalFrame.Header>
          <h2 className="min-w-0 text-xl font-bold text-light-text-primary dark:text-dark-text-primary sm:text-2xl">{title}</h2>
          <button
            onClick={onClose}
            className="text-light-text-tertiary dark:text-dark-text-tertiary hover:text-light-text-primary dark:hover:text-dark-text-primary"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </ModalFrame.Header>

        <ModalFrame.Body>
          <TalentForm
            initialData={initialData}
            onCancel={onClose}
            onSuccess={(response) => {
              onSuccess?.(response);
              onClose();
            }}
            title=""
            submitText={submitText}
            showHeader={false}
            jobApplicationInfo={jobApplicationInfo}
            isModal={true}
          />
        </ModalFrame.Body>
      </ModalFrame>
    </ModalPortal>
  );
};

export default TalentFormModal;
